import { render, staticRenderFns } from "./NeedsAIChat.vue?vue&type=template&id=890ccd9c&scoped=true&"
import script from "./NeedsAIChat.vue?vue&type=script&setup=true&lang=js&"
export * from "./NeedsAIChat.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./NeedsAIChat.vue?vue&type=style&index=0&id=890ccd9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890ccd9c",
  null
  
)

export default component.exports